module.exports = __webpack_public_path__ + "img/event-flag-red.0d8327c3.svg";